export function handleSeriesData(props, accessibilityGraphStyles) {
    const array = []
    const isChartWithBackgroundFill = props.graphType === "bar" || props.graphType === "column" ||props.graphType === "area"
    props.graphData.map((item, index) => { 
        array.push({ 
            name: item.name, 
            data: item.data.map((item) => item.value), 
            dashStyle: isChartWithBackgroundFill ? "" : getCycledItem(index, accessibilityGraphStyles),
            style: isChartWithBackgroundFill ? "" : getCycledItem(index, accessibilityGraphStyles)
        })
    })
    
    return array
}

export function getCycledItem(index, array) {
    // index - 1 to convert to 0-based, then modulo array length
    return array[(index - 1) % array.length]
}   